import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import EntryGate from "@/components/EntryGate";
import AuthModal from "@/components/AuthModal";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Standards from "@/pages/Standards";
import Testing from "@/pages/Testing";
import Materials from "@/pages/Materials";
import MaterialDetail from "@/pages/MaterialDetail";
import Account from "@/pages/Account";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Admin from "@/pages/Admin";
import VerifyEmail from "@/pages/VerifyEmail";
import ResetPassword from "@/pages/ResetPassword";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import ResearchUse from "@/pages/ResearchUse";

function App() {
    return (
        <div className="min-h-screen bg-ink text-slate-800">
            <div className="grain-overlay" aria-hidden="true" />
            <BrowserRouter>
                <AuthProvider>
                    <FavoritesProvider>
                        <CartProvider>
                        <ScrollToTop />
                        <EntryGate />
                        <AuthModal />
                        <Navbar />
                        <main>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/standards" element={<Standards />} />
                                <Route path="/testing" element={<Testing />} />
                                <Route path="/materials" element={<Materials />} />
                                <Route path="/materials/:id" element={<MaterialDetail />} />
                                <Route path="/account" element={<Account />} />
                                <Route path="/cart" element={<Cart />} />
                                <Route path="/checkout" element={<Checkout />} />
                                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                                <Route path="/admin" element={<Admin />} />
                                <Route path="/verify-email" element={<VerifyEmail />} />
                                <Route path="/reset-password" element={<ResetPassword />} />
                                <Route path="/faq" element={<FAQ />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/privacy" element={<Legal title="Privacy Policy" />} />
                                <Route path="/terms" element={<Legal title="Terms of Use" />} />
                                <Route path="/research-use" element={<ResearchUse />} />
                            </Routes>
                        </main>
                        <Footer />
                        </CartProvider>
                    </FavoritesProvider>
                </AuthProvider>
            </BrowserRouter>
            <Toaster position="bottom-right" theme="light" />
        </div>
    );
}

export default App;
